module.exports = __webpack_public_path__ + "img/2b.264363c8.jpg";